import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRocketLaunch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4124 5.1437C14.0943 4.19064 16.2679 3.78395 19.1678 3.99108C19.5649 4.01945 19.8808 4.33536 19.9092 4.73248C20.1163 7.63232 19.7096 9.80592 18.7565 11.4878C17.8853 13.0252 16.6037 14.0701 15.1084 14.8808V16.0601C15.1084 16.7612 14.8021 17.4272 14.2698 17.8834L12.0273 19.8056C11.8252 19.9788 11.5504 20.0402 11.2939 19.9696C11.0374 19.899 10.8328 19.7056 10.7478 19.4536L10.7459 19.448L10.7383 19.4259C10.7313 19.4059 10.7206 19.3752 10.7063 19.3352C10.6776 19.2551 10.6346 19.1376 10.5786 18.9916C10.4662 18.6991 10.3026 18.2952 10.0979 17.8508C9.67677 16.9365 9.12475 15.9472 8.53892 15.3613C7.95308 14.7755 6.96371 14.2235 6.04945 13.8023C5.60506 13.5976 5.20115 13.434 4.9086 13.3217C4.76261 13.2656 4.64509 13.2226 4.56501 13.1939C4.52499 13.1796 4.49438 13.1689 4.4743 13.1619L4.45223 13.1543L4.4474 13.1527C4.19534 13.0677 4.00122 12.8628 3.93062 12.6064C3.86001 12.3498 3.92147 12.075 4.09462 11.873L6.01682 9.63042C6.47304 9.09816 7.13907 8.79183 7.84009 8.79183H9.01948C9.83014 7.29654 10.875 6.0149 12.4124 5.1437ZM14.7082 10.793C15.5923 10.793 16.3091 10.0762 16.3091 9.19206C16.3091 8.30789 15.5923 7.59113 14.7082 7.59113C13.824 7.59113 13.1072 8.30789 13.1072 9.19206C13.1072 10.0762 13.824 10.793 14.7082 10.793Z"
      fill="currentColor"
    />
    <path
      d="M6.46909 15.8302C6.78169 16.1428 6.78169 16.6497 6.46909 16.9623L4.46793 18.9634C4.15533 19.276 3.64851 19.276 3.33591 18.9634C3.0233 18.6508 3.0233 18.144 3.33591 17.8314L5.33706 15.8302C5.64966 15.5176 6.15649 15.5176 6.46909 15.8302Z"
      fill="currentColor"
    />
    <path
      d="M8.07002 18.5632C8.38262 18.2506 8.38262 17.7438 8.07002 17.4312C7.75742 17.1186 7.25059 17.1186 6.93799 17.4312L5.7373 18.6319C5.4247 18.9445 5.4247 19.4513 5.7373 19.7639C6.0499 20.0765 6.55672 20.0765 6.86932 19.7639L8.07002 18.5632Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgRocketLaunch;
